import { MdMenuOpen } from "react-icons/md";
import { LuMessageSquare } from "react-icons/lu";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CiImageOn, CiSettings  } from "react-icons/ci";
import { MdContentPaste } from "react-icons/md";
import { LiaUserSolid } from "react-icons/lia";
import { TbLogs } from "react-icons/tb";

export default function SideMenu() {
  const [menuClosed, SetMenuClosed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      className={`border bg-white-r p-4 h-screen w-full sticky top-0 ${
        menuClosed ? "max-w-[80px]" : "max-w-[250px]"
      } duration-300 space-y-6`}
    >
      <div className="flex items-center">
        {menuClosed === true && (
          <img
            onClick={() => SetMenuClosed(false)}
            className="w-[60px] cursor-pointer h-[46px]"
            src="/images/logo_icon.jpg"
            alt="logo"
          />
        )}
        <div className="w-full">
          {menuClosed === false && (
            <img className="h-[46px]" src="/images/logo.svg" alt="logo" />
          )}
        </div>

        {menuClosed === false && (
          <MdMenuOpen
            onClick={() => SetMenuClosed(true)}
            className="text-[24px] cursor-pointer"
          />
        )}
      </div>

      {/* Site */}
      <div>
        {menuClosed === false && <p className="uppercase font-[600] text-black/default pb-2">site</p>}

        <div
          onClick={() => navigate("/dashboard/testimonial")}
          className={`flex items-center space-x-2 p-2 hover:bg-primary/[.20] rounded mt-2 hover:cursor-pointer duration-300 ${
            location.pathname === "/dashboard/testimonial"
              ? "bg-primary/[.20]"
              : ""
          } ${menuClosed ? "ml-0 flex justify-center py-3" : "ml-2"}`}
        >
          <LuMessageSquare className="text-[20px]" />
          {menuClosed === false && <p>Testimonial</p>}
        </div>

        <div
          onClick={() => navigate("/dashboard/content")}
          className={`flex items-center space-x-2 p-2 rounded mt-2 hover:bg-primary/[.20] hover:cursor-pointer duration-300 ${
            location.pathname === "/dashboard/content" ? "bg-primary/[.20]" : ""
          } ${menuClosed ? "ml-0 flex justify-center py-3" : "ml-2"}`}
        >
          <MdContentPaste className="text-[20px]" />
          {menuClosed === false && <p>Content</p>}
        </div>

        <div
          onClick={() => navigate("/dashboard/portfolio")}
          className={`flex items-center space-x-2 p-2 rounded mt-2 hover:bg-primary/[.20] hover:cursor-pointer duration-300 ${
            location.pathname === "/dashboard/portfolio"
              ? "bg-primary/[.20]"
              : ""
          } ${menuClosed ? "ml-0 flex justify-center py-3" : "ml-2"}`}
        >
          <CiImageOn className="text-[20px]" />
          {menuClosed === false && <p>Portfolio</p>}
        </div>
      </div>

      {/* Support */}

      {menuClosed === true && <hr/>}

      <div>
        {menuClosed === false && <p className="uppercase font-[600] text-black/default pb-2">Support</p>}

        <div
          onClick={() => navigate("/dashboard/logs")}
          className={`flex items-center space-x-2 p-2 hover:bg-primary/[.20] rounded mt-2 hover:cursor-pointer duration-300 ${
            location.pathname === "/dashboard/logs"
              ? "bg-primary/[.20]"
              : ""
          } ${menuClosed ? "ml-0 flex justify-center py-3" : "ml-2"}`}
        >
          <TbLogs className="text-[20px]" />
          {menuClosed === false && <p>Logs</p>}
        </div>

      </div>
    </div>
  );
}
